import { InitAuth  } from "./components/Auth/auth.modules.js";
import Subdomains from "./components/Subdomains/subdomains.module.js";
import { useSubdomains } from "./components/Subdomains/store.js";
import { useAuth } from "./components/Auth/store.js";
import AuthService from "./components/Auth/auth.modules.js";

export function InitApp() {    
    Subdomains.loadSettings()
    .then((data) => {            
        useSubdomains.setState({subdomainSettings: data, isPresetExist: typeof(data) != 'undefined'});            
    })
    .catch(() => {
        console.log('no file');
        useSubdomains.setState({isPresetExist: false});
    })
    .finally(() => {
        //если не авторизован и только пользователь по умолчанию - принудительно авторизуем с пользователем по умолчанию
        const auth = useAuth.getState();
        const subDomain = useSubdomains.getState();
        if (!auth.isAuth && subDomain?.subdomainSettings?.default_user?.default_user_only) {
            AuthService.login(
                subDomain?.subdomainSettings?.default_user?.user, 
                subDomain?.subdomainSettings?.default_user?.password, 
            )
            .then( (data) => {
                AuthService.afterLogon(data)
            });
        } 
        //иначе просто проверяем аутентификацию
        else 
            InitAuth(); 
    })

}